import { Route, Switch } from "react-router-dom";
import { routeConfig } from "@monorepo/constants/routeConfig";
import { lazyWithRetry } from "@monorepo/helpers";

const FAQAccordion = lazyWithRetry(() => import("components/FAQ/FAQAccordion/FAQAccordion"));
const Contacts = lazyWithRetry(() => import("components/Contacts/Contacts"));

interface IProps {
  faqGroupId?: string;
}

export const Help = ({ faqGroupId }: IProps) => {
  return (
    <Switch>
      <Route exact path={routeConfig.dashboard.help.self}>
        <Contacts />
      </Route>
      <Route exact path={routeConfig.dashboard.help.faqGroup.groupId}>
        {faqGroupId ? <FAQAccordion faqGroupId={faqGroupId} /> : null}
      </Route>
    </Switch>
  );
};
